import PropTypes from 'prop-types';
import Panel from 'components/global/Panel';
import GlobalTitle from 'components/global/Title';
import GlobalTabs from 'components/global/Tabs';

function SectionTopBar({ title, activeTab, tabs, style = undefined }) {
  return (
    <div style={style}>
      <Panel style={{ paddingBottom: '50px' }}>
        <GlobalTitle title={title} />
        <GlobalTabs activeTab={activeTab} tabs={tabs} />
      </Panel>
    </div>
  );
}

SectionTopBar.propTypes = {
  title: PropTypes.node.isRequired,
  activeTab: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      heading: PropTypes.node.isRequired,
    }),
  ).isRequired,
  style: PropTypes.object,
};

export default SectionTopBar;
